import TalentListPage from '../components/Talent/TalentListPage'
import talentStatusesConfig from '../../../shared/talentStatuses.json'

const ACTIVE_STATUSES = talentStatusesConfig.ACTIVE_STATUSES || [];

const EmployeesActive = () => {
  return (
    <>
      <title>Active Employees | Talent Service</title>
      <TalentListPage
        talentType="employee"
        statusNames={ACTIVE_STATUSES.join(', ')}
        pageTitle="Active Employees"
        pageDescription="Employees with active statuses: Available, Full Project + Part Time, Part Project + Full Time, Part Project + Part Time, Work"
        defaultFilters={{ is_active: 'true', current_only: 'true' }}
      />
    </>
  )
}

export default EmployeesActive
